export default {"src":"/_next/static/media/arrow-down.27fa6f20.svg","height":16,"width":16};